import React, { useState, useEffect } from 'react'
import { AppDispatch, RootState } from 'store'

import { useDispatch, useSelector } from 'react-redux'
import { TriggersBasicInfo } from './IssueTriggersBasicInfo'
import {
  ContentWrapper,
  Flex,
  H1WithBack,
  PageWrapper,
  Tabs,
  TabsContainer,
} from 'styling/GlobalStyles'
import { NavBar } from 'components/NavBar/NavBar'
import { TriggersCompaniesTab } from './IssueTriggersCompaniesTab'
import { getSingleIssue } from 'features/issues/issuesSlice'
import { useNavigate, useParams } from 'react-router-dom'
import {
  clearIssueTrigger,
  getSingleIssueTrigger,
  updateIssueTrigger,
} from 'features/triggers/issueTriggersSlice'
import { getCompaniesSimple } from 'features/companies/companiesSlice'
import { IssueTriggersTasksTab } from './IssueTriggersTasksTab'
import { toast } from 'react-toastify'
import { IssueTriggersProcessesTab } from './IssueTriggersProcessesTab'
import { IssueTriggersCyclesTab } from './IssueTriggersCyclesTab'
import { IIssueTriggerState } from 'types/issue-triggers.interface'
import { issueTriggersInitialState } from './issueTriggersData'

export const EditTriggers = () => {
  const { singleIssue } = useSelector((store: RootState) => store.issues)
  const [active, setActive] = useState('Basic Info')
  const { singleIssueTrigger } = useSelector((store: RootState) => store.issueTriggers)
  const navigate = useNavigate()
  const dispatch = useDispatch<AppDispatch>()
  const [invalidFields, setInvalidFields] = useState([])
  const { id } = useParams()
  const [state, setState] = useState<IIssueTriggerState>(issueTriggersInitialState)

  const handleSubmit = async () => {
    if (invalidFields.length > 0) {
      toast.warn('All basic info fields must be valid.')
      return
    }

    const resp = await dispatch(updateIssueTrigger(state))

    if (resp.meta.requestStatus === 'fulfilled') {
      navigate('/triggers-issue')
    }
  }

  useEffect(() => {
    dispatch(getSingleIssueTrigger(id))
    return () => {
      dispatch(clearIssueTrigger())
    }
  }, [])


  useEffect(() => {
    if (singleIssueTrigger) {
      const obj = structuredClone(singleIssueTrigger)
      setState(obj)
    }
    singleIssueTrigger?.issue?.id && dispatch(getSingleIssue(singleIssueTrigger?.issue?.id))
  }, [singleIssueTrigger])

  const triggerSimpleRequest = (value) => {
    dispatch(getSingleIssue(value))
    dispatch(getCompaniesSimple(value))
  }

  const renderTabs = () => {
    if (active === 'Basic Info') {
      return (
        <TriggersBasicInfo
          state={state}
          setState={setState}
          handleSubmit={handleSubmit}
          invalidFields={invalidFields}
          setInvalidFields={setInvalidFields}
          triggerSimpleRequest={triggerSimpleRequest}
        />
      )
    } else if (active === 'Companies') {
      return (
        <TriggersCompaniesTab
          state={state}
          setState={setState}
          singleIssue={singleIssue}
          handleSubmit={handleSubmit}
        />
      )
    } else if (active === 'Tasks') {
      return <IssueTriggersTasksTab state={state} setState={setState} handleSubmit={handleSubmit} />
    }
    else if (active === 'Cycles') {
      return <IssueTriggersCyclesTab state={state} setState={setState} handleSubmit={handleSubmit} />
    }
    else if (active === 'Processes') {
      return <IssueTriggersProcessesTab state={state} setState={setState} handleSubmit={handleSubmit} />
    }

  }

  const handleCompanies = () => {
    if (state.issue.id && 'Companies') {
      setActive('Companies')
      return
    }
    toast.error('Please select an issue event')
  }

  return (
    <>
      <NavBar />
      <PageWrapper noFooter>
        <Flex between main>
          <H1WithBack mb='1.5' arrow title='Edit Issue Trigger' />
          <TabsContainer>
            <Tabs active={active === 'Basic Info'} onClick={() => setActive('Basic Info')}>
              Basic Info
            </Tabs>
            <Tabs active={active === 'Companies'} onClick={() => handleCompanies()}>
              Companies
            </Tabs>
            <Tabs active={active === 'Tasks'} onClick={() => setActive('Tasks')}>
              Tasks
            </Tabs>
            <Tabs active={active === 'Cycles'} onClick={() => setActive('Cycles')}>
              Cycles
            </Tabs>
            <Tabs active={active === 'Processes'} onClick={() => setActive('Processes')}>
              Processes
            </Tabs>
          </TabsContainer>
        </Flex>
        <Flex between></Flex>
        <ContentWrapper>{renderTabs()}</ContentWrapper>
      </PageWrapper>
    </>
  )
}
